// v2 烧录 Progress 负值枚举:
// -1 用户取消
// -2 烧录请求报错，取消升级
// -3 下位机取消

export function parseBurnProgress(progress) {
    if (progress == null || progress === '') {
        return null;
    }
    const p = parseInt(progress, 10);
    return Number.isNaN(p) ? null : p;
}

export function isBurnCancelled(progress) {
    const p = parseBurnProgress(progress);
    return p !== null && p < 0;
}

export function v2BurnCancelLabel(progress, t) {
    const p = parseBurnProgress(progress);
    if (p === -1) {
        return t('cancelled by user');
    }
    if (p === -2) {
        return t('upgrade cancelled: burn request failed');
    }
    if (p === -3) {
        return t('cancelled by device');
    }
    return t('ignored');
}

export function v2BurnProgressLabel(progress, sTime, eTime, t) {
    const p = parseBurnProgress(progress);
    if (p !== null && p < 0) {
        return v2BurnCancelLabel(p, t);
    }
    if (sTime == null) {
        return t('to be burned');
    }
    if (eTime != null) {
        return t('burned');
    }
    return t('burning');
}
